import { EmailBlacklistEditIn, EmailBlacklistEditOut, EmailBlacklistListOut } from "../../../../model/notificaciones";
import { PaginatedResponse, Response } from '../../../../model';
import ServiceBase from "../../../servicebase";

export default class EmailBlacklistService extends ServiceBase {
  getEdit = (data:{ id?: number }) => this.GetFetch<Response<EmailBlacklistEditOut>>('notificaciones/emailblacklist/edit', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?: number, email?: string, activo?: boolean }) => 
    this.GetFetch<PaginatedResponse<EmailBlacklistListOut>>('notificaciones/emailblacklist/find', data);

  upsert = (data:EmailBlacklistEditIn) => this.PostFetch<Response<number>>('notificaciones/emailblacklist', data);

  delete = (data:{ id:number, undelete?: boolean}) => this.DeleteFetch<Response<void>>('notificaciones/emailblacklist', data);
}
